import { Directive, input, type OnInit, type InputSignal } from '@angular/core';
import { ModalCloseReason } from '../../modal.domain';
import { ModalCloseBase } from './modal-close-base';

export type { ModalCloseEvent } from './modal-close.contract';

/**
 * Will attach click handler to the element it is applied to that will close the current modal.
 */
@Directive({
  selector: '[tdWbModalClose]',
  exportAs: 'tdWbModalClose',
  host: {
    '(click)': 'onClick()'
  }
})
export class ModalCloseDirective extends ModalCloseBase implements OnInit {

  readonly closeResult: InputSignal<string | undefined> = input<string>(undefined, { alias: 'tdWbModalClose' });

  onClick(): void {
    const reason = this.closeResult() === '' ? ModalCloseReason.HEADER_BUTTON : this.closeResult();
    super.close(reason);
  }

  // ModalRef instances are created dynamically and not available for constructor DI.
  // So deferring retrieving most recent modal reference until after component is initialized.
  ngOnInit(): void {
    this.modalRef = this.modalService.getTopModal();
  }

}
